import React, { useEffect, useState } from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import constants from '../constants'

const { SIDEBAR_WIDTH } = constants;

export default function ImageSidebarLayout(props) {
  const { image, sidebar } = props;

  const [scrollbarWidth, setScrollbarWidth] = useState(window.innerWidth - document.body.clientWidth);

  // calculate scrollbar width when things are loaded
  useEffect(() => {
    setScrollbarWidth(window.innerWidth - document.body.clientWidth);
  }, []);

  return (
    <Container>
      <ImageContainer>
        <ImageContent scrollbarWidth={scrollbarWidth}>
          {image}
        </ImageContent>
      </ImageContainer>
      <Sidebar>
        {sidebar}
      </Sidebar>
    </Container>
  );
}

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  [theme.mediaQueries.md]: {
    flexDirection: 'row'
  }
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  position: 'relative',

  [theme.mediaQueries.md]: {
    width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
  }
}));

const ImageContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',

  [theme.mediaQueries.md]: {
    /** position fixed caused some layout shift problem with short sidebar, and modal */
    position: 'sticky',
    top: 0,

    width: '100%',
    height: '100vh'
  }
}));

const Sidebar = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',

  [theme.mediaQueries.md]: {
    width: SIDEBAR_WIDTH,
  }
}));
